import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('post', `/api/courses/${id}/add-students-to-course-csv`, payload);


// WEBPACK FOOTER //
// ./src/app/services/courses/addStudentToCourseCSV.js